(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tj-scripts"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.toJanEditorial) return;
  window.toJanEditorial = true;
  const configNode = document.getElementById('tj-config');
  if (!configNode) return;
  document.documentElement.classList.add('tj-js');
  let conf = JSON.parse(configNode.textContent);
  const esc = (s) => String(s ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const money = (cents, currency) => new Intl.NumberFormat(conf.locale, {style:'currency', currency:currency || conf.currency}).format(cents / 100);
  let opener = null;
  let cartLoading = false;
  const open = (id, trigger) => {
    const dialog = document.getElementById(id);
    if (!dialog) return;
    document.querySelectorAll('dialog[open]').forEach(d => d.close());
    opener = trigger || document.activeElement;
    dialog.showModal();
    if (trigger) trigger.setAttribute('aria-expanded','true');
  };
  document.addEventListener('close', event => {
    if (!event.target.matches('dialog')) return;
    document.querySelectorAll('[data-open][aria-expanded="true"]').forEach(el => el.setAttribute('aria-expanded','false'));
    if (opener && opener.isConnected) opener.focus({preventScroll:true});
  }, true);
  document.addEventListener('click', event => {
    const dialog=event.target;
    if (!dialog.matches('dialog[open]')) return;
    const rect=dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
  const headerScroll = () => {
    document.querySelector('[data-header]')?.classList.toggle('is-scrolled', window.scrollY > 45);
  };
  window.addEventListener('scroll', headerScroll, {passive:true});
  headerScroll();
  const renderCart = (cart) => {
    document.querySelectorAll('[data-cart-count]').forEach(e => {e.textContent=cart.item_count; e.hidden=cart.item_count===0;});
    const target = document.querySelector('[data-cart-items]');
    const summary = document.querySelector('[data-cart-summary]');
    if (!target || !summary) return;
    summary.hidden = cart.item_count === 0;
    if (!cart.item_count) { target.innerHTML = '<p class="tj-empty">'+esc(conf.empty)+'</p>'; return; }
    target.innerHTML = cart.items.map(item => `<article class="tj-cart-item"><a href="${esc(item.url)}">${item.image?`<img src="${esc(item.image)}" width="92" height="123" alt="${esc(item.product_title)}">`:''}</a><div><h3><a href="${esc(item.url)}">${esc(item.product_title)}</a></h3><p>${esc(item.variant_title === 'Default Title' ? '' : item.variant_title)}</p><p>${esc(money(item.final_line_price,cart.currency))}</p><div class="tj-cart-item-controls"><input type="number" min="0" value="${item.quantity}" data-cart-quantity="${esc(item.key)}" aria-label="${esc(conf.quantity)}"><button type="button" data-remove="${esc(item.key)}">${esc(conf.remove)}</button></div></div></article>`).join('');
    document.querySelector('[data-cart-subtotal]').textContent = money(cart.total_price,cart.currency);
  };
  const getCart = async () => {
    if (cartLoading || !document.querySelector('[data-cart-items]')) return;
    cartLoading = true;
    try {
      document.querySelector('[data-cart-items]').textContent = conf.loading;
      const res = await fetch(conf.cart+'.js', {headers:{Accept:'application/json'}});
      if (!res.ok) throw new Error(conf.error);
      renderCart(await res.json());
    } catch (error) { const target=document.querySelector('[data-cart-items]');if(target)target.textContent=conf.error; }
    finally { cartLoading=false; }
  };
  const changeCart = async (key,quantity,control) => {
    if (control) control.disabled=true;
    try {
      const res = await fetch(conf.cartChange+'.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:key,quantity})});
      const data=await res.json();
      if (!res.ok) throw new Error(data.description || data.message || conf.error);
      renderCart(data);
    } catch(error) {
      const p=document.createElement('p');p.setAttribute('role','alert');p.textContent=error.message;document.querySelector('[data-cart-items]').prepend(p);
      if(control) control.disabled=false;
    }
  };
  const updateVariant = (select) => {
    const form=select.closest('form'), section=form.closest('[data-product-section]');
    const option=select.selectedOptions[0];
    const button=form.querySelector('[data-add]');
    const available=option.dataset.available==='true';
    const pending=Number(option.dataset.numericPrice)===0;
    button.disabled=!available || pending;
    button.textContent=pending?conf.comingSoon:available?(button.dataset.addLabel || conf.add):conf.soldOut;
    const price=section.querySelector('[data-product-price]');
    if(price)price.textContent=pending?conf.pending:option.dataset.price;
    form.querySelectorAll('[data-variant-id]').forEach(b=>{const on=b.dataset.variantId===select.value;b.classList.toggle('is-selected',on);b.setAttribute('aria-pressed',String(on));});
    const url=new URL(window.location.href);url.searchParams.set('variant',select.value);history.replaceState({},'',url);
    form.querySelector('[data-form-message]').textContent='';
  };
  document.addEventListener('click',async event=>{
    const target=event.target.closest('button,a');if(!target)return;
    if(target.hasAttribute('data-open')) {event.preventDefault();open(target.dataset.open,target);}
    if(target.hasAttribute('data-close')) {target.closest('dialog')?.close();}
    if(target.hasAttribute('data-open-cart') && document.getElementById('tj-cart')) {event.preventDefault();open('tj-cart',target);await getCart();}
    if(target.hasAttribute('data-remove')) await changeCart(target.dataset.remove,0,target);
    if(target.hasAttribute('data-quantity')) {const input=target.parentElement.querySelector('input');input.value=Math.max(1,Number(input.value||1)+Number(target.dataset.quantity));}
    if(target.hasAttribute('data-variant-id')) {const select=target.closest('form').querySelector('[data-variant-select]');select.value=target.dataset.variantId;updateVariant(select);}
    if(target.hasAttribute('data-carousel')) {const row=document.getElementById(target.dataset.carousel);row?.scrollBy({left:row.clientWidth * .9 * Number(target.dataset.direction),behavior:'smooth'});}
    if(target.hasAttribute('data-grid-toggle')) {const grid=document.querySelector('[data-product-grid]');const on=grid.classList.toggle('is-dense');target.setAttribute('aria-pressed',String(on));}
    if(target.hasAttribute('data-zoom')) {const img=document.querySelector('[data-zoom-image]');img.src=target.dataset.zoom;img.alt=target.querySelector('img')?.alt||'';open('tj-zoom',target);}
    if(target.hasAttribute('data-announcement-step')) {const items=[...target.closest('[data-announcement]').querySelectorAll('[data-announcement-item]')];if(items.length<2)return;let i=Math.max(0,items.findIndex(e=>!e.hidden));items[i].hidden=true;i=(i+Number(target.dataset.announcementStep)+items.length)%items.length;items[i].hidden=false;}
  });
  document.addEventListener('change',event=>{
    const t=event.target;
    if(t.matches('[data-variant-select]'))updateVariant(t);
    if(t.matches('[data-cart-quantity]'))changeCart(t.dataset.cartQuantity,Math.max(0,Math.floor(Number(t.value)||0)),t);
  });
  document.addEventListener('submit',async event=>{
    const form=event.target;if(!form.matches('.tj-product-form'))return;
    const button=form.querySelector('[data-add]');
    event.preventDefault();
    if(button.disabled||form.dataset.pending)return;
    form.dataset.pending='true';button.disabled=true;
    const message=form.querySelector('[data-form-message]');
    try {
      const data=new FormData(form);data.delete('form_type');data.delete('utf8');
      const res=await fetch(conf.cartAdd+'.js',{method:'POST',headers:{Accept:'application/json'},body:data});
      const result=await res.json();
      if(!res.ok)throw new Error(result.description||result.message||conf.error);
      message.textContent=conf.added;
      if(document.getElementById('tj-cart')){open('tj-cart',button);await getCart();}
      else window.location.assign(conf.cart);
    }catch(error){message.textContent=error.message;message.setAttribute('role','alert');}
    finally{delete form.dataset.pending;button.disabled=false;}
  });
  if (window.Shopify?.designMode) {
    let selectedBlockId=null;
    const previewBlock = (element) => {
      if (!element) return;
      if (element.matches('[data-announcement-item]')) {
        element.closest('[data-announcement]').querySelectorAll('[data-announcement-item]').forEach(item=>item.hidden=item!==element);
      }
      if (element.matches('[data-menu-block]')) {
        open('tj-menu');
        if(element.matches('details'))element.open=true;
      } else if(element.matches('[data-open]')) {
        open(element.dataset.open);
      } else if(element.matches('[data-open-cart]')) {
        open('tj-cart');getCart();
      }
    };
    document.addEventListener('shopify:block:select', event=>{
      selectedBlockId=event.detail.blockId;
      previewBlock(event.target);
    });
    document.addEventListener('shopify:block:deselect', ()=>{selectedBlockId=null;document.querySelectorAll('dialog[open]').forEach(dialog=>dialog.close());});
    document.addEventListener('shopify:section:load', ()=>{
      const node=document.getElementById('tj-config');
      if(node)conf=JSON.parse(node.textContent);
      headerScroll();
      if(!selectedBlockId)return;
      const element=[...document.querySelectorAll('[data-shopify-editor-block]')].find(el=>{
        try{return JSON.parse(el.getAttribute('data-shopify-editor-block')).id===selectedBlockId;}catch{return false;}
      });
      previewBlock(element);
    });
    document.addEventListener('shopify:section:unload', event=>event.target.querySelectorAll('dialog[open]').forEach(dialog=>dialog.close()));
  }
})();
  } catch(e) { console.error(e); }
})();

})();
